const selectedMultipleItems = (_count, _name = 'items') => `Selected ${_count} ${_name}\u2026`;

const otherItemSuffix = _value => `(+${_value} others)`;

export default {
  selectedMultipleItems,
  otherItemSuffix,
};
